import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Selectors from '../redux/selectors';
import { updateQuery, sortRequestAction } from '../redux/actions';
import { SortingBar } from '../../shared/components/SortingBar';
import { getGTMSortOrderEvent, getGTMFilterButtonEvent } from '../utils/gtmEvents';

const SortBarContainer = (props) => {
  const { dispatch, selectedOrderBy, texts } = props;

  const handleSortClick = useCallback(
    (event) => {
      const value = event?.target?.value;

      if (value) {
        dispatch(updateQuery({ orderBy: value, page: 1 }, getGTMSortOrderEvent(value)));
        dispatch(sortRequestAction());
      }
    },
    [dispatch],
  );

  const handleOpenFilters = useCallback(() => {
    dispatch(updateQuery({ filter: true }, getGTMFilterButtonEvent()));
  }, [dispatch]);

  return (
    <SortingBar
      dateSortLabel={texts.sortByDate}
      priceSortLabel={texts.sortByPrice}
      filterLabel={texts.filter}
      onSortClick={handleSortClick}
      onOpenFilters={handleOpenFilters}
      active={selectedOrderBy}
    />
  );
};

SortBarContainer.propTypes = {
  dispatch: PropTypes.func,
  texts: PropTypes.object,
  selectedOrderBy: PropTypes.string,
};

function mapStateToProps(state) {
  const query = Selectors.getQueryParams(state);

  return {
    selectedOrderBy: query.orderBy,
  };
}

export const ConnectedSortBarContainer = connect(mapStateToProps)(SortBarContainer);

export default ConnectedSortBarContainer;
